module.exports = "<p> תיאום פגישות.<br>גיוס לקוחות חדשים ושימור לקוחות קיימים.<br>ניהול מו״מ עד לשלב סגירת העסקה.<br>משכורת בסיס + עמלות. </p> <p><strong>דרישות:</strong></p> <ul> <li><p>הכרות עם עולם האינטרנט והמובייל - חובה</p> </li> <li><p>ניסיון במכירות שטח /פרונטאליות שנתיים לפחות - חובה</p> </li> <li><p>רישיון נהיגה - חובה</p> </li> <li><p>יכולת ניהול מו&quot;מ, יכולת פרזנטציה</p> </li> <li><p>התבטאות וניסוח טובים</p> </li> </ul> <p><strong>קורות חיים נא לשלוח ל- <a href=mailto:info@onmap.co.il>info@onmap.co.il</a></strong></p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/vacancies/en/sales.md
// module id = 819
// module chunks = 0